if (!customElements.get('stock-display')) {
    const DRAWER_MODAL_TRANSITION_MS = 320;
    const AU_STATE_NAMES = {
        NSW: 'New South Wales',
        VIC: 'Victoria',
        QLD: 'Queensland',
        SA: 'South Australia',
        WA: 'Western Australia',
        TAS: 'Tasmania',
        NT: 'Northern Territory',
        ACT: 'Australian Capital Territory',
    };

    class StockDisplay extends HTMLElement {
        productAvailabilityCache = null;

        constructor() {
            super();
            this.currentStoreCookie = this.getCookie('currentStore');
            this.stockDisplayQueryId = this.dataset.stockDisplayQueryId;
            this.blockClickCollect = String(this.dataset.blockClickCollect).toLowerCase() === 'true';
            this.isProductSoldOut = String(this.dataset.productSoldOut).toLowerCase() === 'true';
            this.variantInventoryQuantity = parseInt(this.dataset.variantInventory, 10) || 0;
            this.storeNameElement = this.querySelector('.stock-display__store-name');
            this.storeCheckElement = this.querySelector('.stock-display__store-check');
            this.checkAvailabilityButton = this.querySelector('#stock-display__check-availability');
            this.storeButtonChevronElement = this.querySelector('#stock-display__store-button-chevron');
            this.inStorePanelElement = this.querySelector('#stock-display__in-store-panel');
            this.inStoreListElement = this.querySelector('#stock-display__in-store-list');
            this.inStoreTitleElement = this.querySelector('#stock-display__in-store-title');
            this.inStoreDescriptionElement = this.querySelector('#stock-display__in-store-description');
            this.inStorePanelOpen = false;
            this.currentWarehouseStatus = 'out-of-stock';
            this.inStoreAvailabilityModalElement = this.querySelector('#stock-display__availability-modal');
            this.inStoreAvailabilityModalListElement = this.querySelector('#stock-display__availability-modal-list');
            this.inStoreAvailabilityModalCloseButton = this.querySelector('#stock-display__availability-modal-close');
            this.inStoreAvailabilityModalBackdropElements = this.querySelectorAll('[data-availability-modal-close]');
            this.availabilityStateFilterElement = this.querySelector('#stock-display__availability-state-filter');
            this.availabilityStateFilterFieldElement = this.querySelector('#stock-display__availability-state-filter-field');
            this.availabilityStateDropdown = null;
            this.inStoreAvailabilityModalTriggerElement = null;
            this.selectedAvailabilityState = '';
            this.storeSelectedContentElement = this.querySelector('#stock-display__store-selected-content');
            this.deliveryStatusElement = this.querySelector('#stock-display__status-delivery .stock-display__placeholder');
            this.selectedStoreNameElement = this.querySelector('#stock-display__selected-store-name');
            this.selectedStoreBadgeElement = this.querySelector('#stock-display__status-clickcollect-panel');
            this.selectedStoreReadyElement = this.querySelector('#stock-display__selected-store-ready');
            this.selectedStoreStatusElement = this.querySelector('.stock-display__store-selected-status');
            this.deliveryPanelElement = this.querySelector('.stock-display__panel--delivery');
            this.clickCollectPanelContainer = this.querySelector('.stock-display__panel--click-collect');
            this.storeSelectElement = this.querySelector('#stock-display__store-select');
            this.clickCollectStatusElement = this.querySelector('#stock-display__clickcollect-status');
            this.selectStoreButton = this.querySelector('#stock-display__select-store');
            this.changeStoreButton = this.querySelector('#stock-display__change-store');
            this.storeModalElement = this.querySelector('#stock-display__store-modal');
            this.storeModalListElement = this.querySelector('#stock-display__store-modal-list');
            this.storeStateFilterElement = this.querySelector('#stock-display__store-state-filter');
            this.storeStateFilterFieldElement = this.querySelector('#stock-display__store-state-filter-field');
            this.storeStateDropdown = null;
            this.storeModalCloseButton = this.querySelector('#stock-display__store-modal-close');
            this.storeModalBackdropElement = this.querySelector('[data-store-modal-close]');
            this.storeModalFooterWarningElement = this.querySelector('#stock-display__store-modal-footer-warning');
            this.storeModalWarningDetailElement = this.querySelector('#stock-display__store-modal-warning-detail');
            this.storeModalConfirmButton = this.querySelector('#stock-display__store-modal-confirm');
            this.storeModalDismissButton = this.querySelector('#stock-display__store-modal-dismiss');
            this.deliveryTabElement = this.querySelector('.stock-display__tab[data-tab="delivery"]');
            this.clickCollectTabElement = this.querySelector('.stock-display__tab[data-tab="click-collect"]');
            this.deliveryTabSublabelElement = this.deliveryTabElement?.querySelector('.stock-display__tab-sublabel');
            this.clickCollectTabSublabelElement = this.clickCollectTabElement?.querySelector('.stock-display__tab-sublabel');
            this.tabsElement = this.querySelector('#stock-display__tabs');
            this.fulfillmentElement = this.querySelector('#stock-display__fulfillment');
            this.panelAreaElement = this.querySelector('.stock-display__panel-area');
            this.backInStockPanelElement = this.querySelector('#stock-display__back-in-stock');
            this.viewStoresButton = this.querySelector('#stock-display__view-stores');
            this.deliveryIconElement = this.querySelector('#stock-display__icon-delivery');
            this.clickCollectIconElement = this.querySelector('#stock-display__icon-clickcollect');
            this.tabElements = this.querySelectorAll('.stock-display__tab');
            this.activeTab = 'delivery';
            this.initialDeliveryStateSet = false;
            this.storeModalTriggerElement = null;
            this.pendingModalStoreId = '';
            this.selectedModalState = '';
            this.cartPickupStoreId = '';
            this.cartPickupStoreName = '';
            this.storeChoicesList = [];
            this.datajetLocations = null;
            this.locationsList = [];
            this.productAvailabilityPromise = null;
            this.currentProductId = this.dataset.productId;
            this.currentVariantId = this.dataset.variantId;
            this.currentLocationId = this.currentStoreCookie?.dataId ?? '';
            this.inventoryByVariantId = {};
            this.callStoreText = this.dataset.callStoreText;
            this.inStockText = this.dataset.inStockText;
            this.outOfStockText = this.dataset.outOfStockText;
            this.detachedProductFormActions = [];
            this.detachProductFormTimeouts = [];
            this.init();
        }

        init() {
            const productId = this.currentProductId;
            const variantId = this.currentVariantId;
            const locationId = this.currentLocationId;
            if (this.isProductSoldOut) {
                this.updateDynamicCheckoutVisibility(true);
                this.showOutOfStockCTA();
            }

            this.loadProductAvailability(productId).then(() => {
                this.buildStoreList(variantId);
                this.setCurrentStore();
                this.setStockAvailability(variantId, locationId);
            });
            this.storeModalEvent();
            this.storeCheckEvent();
            this.viewStoresEvent();
            this.inStoreAvailabilityModalEvent();
            this.initCustomSelects();
            this.tabEvent();
            this.onVariantChange();
        }

        tabEvent() {
            this.tabElements.forEach(tab => {
                tab.addEventListener('click', () => {
                    if (this.isFullyOutOfStockOnline(this.currentVariantId, this.currentWarehouseStatus)) return;
                    this.switchToTab(tab.dataset.tab);
                });
            });
        }

        clearActiveTabState() {
            this.activeTab = null;
            this.tabElements.forEach((tabEl) => {
                tabEl.classList.remove('stock-display__tab--active');
                tabEl.setAttribute('aria-selected', 'false');
            });
        }

        isFullyOutOfStockOnline(variantId, warehouseStatus) {
            return this.isInStoreOnlyMode(variantId, warehouseStatus);
        }

        ensureComponentVisible() {
            this.style.removeProperty('display');
        }

        showBackInStockPanel() {
            if (!this.backInStockPanelElement) return;
            this.toggleShow(this.backInStockPanelElement);
            this.backInStockPanelElement.classList.remove('stock-display__panel--hidden');
            this.backInStockPanelElement.setAttribute('aria-hidden', 'false');
        }

        hideBackInStockPanel() {
            if (!this.backInStockPanelElement) return;
            this.toggleHide(this.backInStockPanelElement);
            this.backInStockPanelElement.classList.add('stock-display__panel--hidden');
            this.backInStockPanelElement.setAttribute('aria-hidden', 'true');
        }

        updateBackInStockForm(variantId, warehouseStatus) {
            const fullyOutOfStockOnline = this.isFullyOutOfStockOnline(variantId, warehouseStatus);
            const inStoreOnlyWithRetail = this.isAvailableInStoreOnly(variantId, warehouseStatus);

            if (!this.backInStockPanelElement) return;

            if (fullyOutOfStockOnline && !inStoreOnlyWithRetail) {
                this.hideBackInStockPanel();
                this.showPanelLayer(this.deliveryPanelElement);
                this.hidePanelLayer(this.clickCollectPanelContainer);
                return;
            }

            if (inStoreOnlyWithRetail) {
                this.hideBackInStockPanel();
                this.hidePanelLayer(this.deliveryPanelElement);
                this.hidePanelLayer(this.clickCollectPanelContainer);
                return;
            }

            this.hideBackInStockPanel();

            if (this.deliveryTabElement) {
                this.deliveryTabElement.disabled = false;
                this.deliveryTabElement.setAttribute('aria-disabled', 'false');
            }

            const activeTab = this.activeTab || 'delivery';
            if (activeTab === 'click-collect') {
                this.hidePanelLayer(this.deliveryPanelElement);
                this.showPanelLayer(this.clickCollectPanelContainer);
            } else {
                this.showPanelLayer(this.deliveryPanelElement);
                this.hidePanelLayer(this.clickCollectPanelContainer);
            }
        }

        switchToTab(selectedTab) {
            if (selectedTab === this.activeTab) return;
            if (this.isFullyOutOfStockOnline(this.currentVariantId, this.currentWarehouseStatus)) return;
            if (selectedTab === 'click-collect' && this.clickCollectTabElement?.disabled) return;

            this.activeTab = selectedTab;
            this.tabElements.forEach(tabEl => {
                const isActive = tabEl.dataset.tab === selectedTab;
                tabEl.classList.toggle('stock-display__tab--active', isActive);
                tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            if (selectedTab === 'delivery') {
                this.showPanelLayer(this.deliveryPanelElement);
                this.hidePanelLayer(this.clickCollectPanelContainer);
            } else {
                this.hidePanelLayer(this.deliveryPanelElement);
                this.showPanelLayer(this.clickCollectPanelContainer);
            }

            this.refreshAddToCartButton();
        }

        setPanelStatus(element, iconElement, status, inStockMessage, outOfStockMessage) {
            if (!element) return;

            const isAvailable = status === 'in-stock' || status === 'low-in-stock' || status === 'available';
            element.textContent = isAvailable ? inStockMessage : outOfStockMessage;

            if (iconElement) {
                iconElement.classList.toggle('stock-display__panel-icon--success', isAvailable);
                iconElement.classList.toggle('stock-display__panel-icon--error', !isAvailable);
            }
        }

        setClickCollectPanelWhenNoStore() {
            this.showPanelLayer(this.storeSelectElement);
            this.hidePanelLayer(this.clickCollectStatusElement);
        }

        setClickCollectPanelWithStore(displayName) {
            this.hidePanelLayer(this.storeSelectElement);
            this.showPanelLayer(this.clickCollectStatusElement);
            if (displayName && this.selectedStoreNameElement) {
                this.selectedStoreNameElement.textContent = displayName;
            }
        }

        updateDeliveryTabState(warehouseStatus) {
            if (!this.deliveryTabElement || !this.deliveryTabSublabelElement) return;

            const isAvailable = warehouseStatus === 'in-stock' || warehouseStatus === 'available' || warehouseStatus === 'low-in-stock';
            this.deliveryTabElement.classList.toggle('stock-display__tab--unavailable', !isAvailable);
            this.deliveryTabSublabelElement.textContent = isAvailable ? 'Free with S/PLUS' : 'Out of stock';
        }

        updateClickCollectTabState(clickCollectAvailable) {
            if (!this.clickCollectTabElement || !this.clickCollectTabSublabelElement) return;

            this.clickCollectTabElement.classList.toggle('stock-display__tab--unavailable', !clickCollectAvailable);
            this.clickCollectTabElement.disabled = !clickCollectAvailable;
            this.clickCollectTabElement.setAttribute('aria-disabled', clickCollectAvailable ? 'false' : 'true');
            this.clickCollectTabSublabelElement.textContent = clickCollectAvailable ? 'Ready in 2 hours' : 'Out of stock';

            if (!clickCollectAvailable && this.activeTab === 'click-collect') {
                this.activeTab = 'delivery';
                this.tabElements.forEach((tabEl) => {
                    const isActive = tabEl.dataset.tab === 'delivery';
                    tabEl.classList.toggle('stock-display__tab--active', isActive);
                    tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });

                if (!this.isFullyOutOfStockOnline(this.currentVariantId, this.currentWarehouseStatus)) {
                    this.showPanelLayer(this.deliveryPanelElement);
                    this.hidePanelLayer(this.clickCollectPanelContainer);
                }
            }
        }

        isDeliveryAvailable(warehouseStatus) {
            if (this.isProductSoldOut) return false;
            return this.normalizeStatus(warehouseStatus) === 'available';
        }

        hasClickCollectAvailableAnywhere(variantId) {
            if (this.isProductSoldOut || this.blockClickCollect) return false;

            const variantInventory = this.getVariantInventory(variantId);

            return this.locationsList.some((location) => {
                if (!this.isStoreEligibleForModal(location)) return false;
                return this.isClickCollectAvailableForLocation(
                    this.getLocationInventory(variantInventory, location.id)
                );
            });
        }

        isInStoreOnlyMode(variantId, warehouseStatus) {
            return !this.isDeliveryAvailable(warehouseStatus)
                && !this.hasClickCollectAvailableAnywhere(variantId);
        }

        isAvailableInStoreOnly(variantId, warehouseStatus) {
            return this.isInStoreOnlyMode(variantId, warehouseStatus)
                && this.hasRetailStoreStock(variantId);
        }

        isFullyOutOfStockEverywhere(variantId, warehouseStatus) {
            return this.isInStoreOnlyMode(variantId, warehouseStatus)
                && !this.hasRetailStoreStock(variantId);
        }

        setFullyOutOfStockFulfillmentState(variantId, warehouseStatus) {
            this.setOnlineFulfillmentVisible(true);
            this.setOnlineFulfillmentTabsVisible(true);
            this.hideBackInStockPanel();

            this.updateDeliveryTabState(warehouseStatus);
            this.updateClickCollectTabState(false);

            if (this.deliveryTabElement) {
                this.deliveryTabElement.disabled = true;
                this.deliveryTabElement.setAttribute('aria-disabled', 'true');
            }

            if (this.clickCollectTabElement) {
                this.toggleShow(this.clickCollectTabElement);
            }

            this.activeTab = 'delivery';
            this.tabElements.forEach((tabEl) => {
                const isActive = tabEl.dataset.tab === 'delivery';
                tabEl.classList.toggle('stock-display__tab--active', isActive);
                tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            this.showPanelLayer(this.deliveryPanelElement);
            this.hidePanelLayer(this.clickCollectPanelContainer);
            this.setStockStatusHtml(this.deliveryStatusElement, warehouseStatus);
        }

        setInStoreOnlyFulfillmentState(variantId, warehouseStatus) {
            this.setOnlineFulfillmentVisible(true);
            this.setOnlineFulfillmentTabsVisible(true);
            this.updateDeliveryTabState(warehouseStatus);
            this.updateClickCollectTabState(false);

            if (this.deliveryTabElement) {
                this.deliveryTabElement.disabled = true;
                this.deliveryTabElement.setAttribute('aria-disabled', 'true');
            }

            if (this.clickCollectTabElement) {
                this.toggleShow(this.clickCollectTabElement);
                this.clickCollectTabElement.disabled = true;
                this.clickCollectTabElement.setAttribute('aria-disabled', 'true');
            }

            this.activeTab = 'delivery';
            this.tabElements.forEach((tabEl) => {
                const isActive = tabEl.dataset.tab === 'delivery';
                tabEl.classList.toggle('stock-display__tab--active', isActive);
                tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            this.showPanelLayer(this.deliveryPanelElement);
            this.hidePanelLayer(this.clickCollectPanelContainer);
            this.setStockStatusHtml(this.deliveryStatusElement, warehouseStatus);
        }

        setOnlineFulfillmentVisible(isVisible) {
            if (!this.fulfillmentElement) return;

            if (isVisible) {
                this.toggleShow(this.fulfillmentElement);
                this.fulfillmentElement.setAttribute('aria-hidden', 'false');
            } else {
                this.toggleHide(this.fulfillmentElement);
                this.fulfillmentElement.setAttribute('aria-hidden', 'true');
            }
        }

        setOnlineFulfillmentTabsVisible(isVisible) {
            if (!this.tabsElement) return;

            if (isVisible) {
                this.toggleShow(this.tabsElement);
                this.tabsElement.setAttribute('aria-hidden', 'false');
            } else {
                this.toggleHide(this.tabsElement);
                this.tabsElement.setAttribute('aria-hidden', 'true');
            }
        }

        updateFulfillmentVisibility(variantId, warehouseStatus) {
            const deliveryAvailable = this.isDeliveryAvailable(warehouseStatus);
            const clickCollectAvailable = this.hasClickCollectAvailableAnywhere(variantId);
            const inStoreOnlyWithRetail = this.isAvailableInStoreOnly(variantId, warehouseStatus);
            const onlineFulfillmentUnavailable = this.isInStoreOnlyMode(variantId, warehouseStatus);

            this.ensureComponentVisible();
            this.classList.toggle('stock-display--in-store-only', inStoreOnlyWithRetail);

            if (onlineFulfillmentUnavailable) {
                if (inStoreOnlyWithRetail) {
                    this.hideBackInStockPanel();
                    this.setInStoreOnlyFulfillmentState(variantId, warehouseStatus);
                    this.showInStoreOnlyExperience(variantId, warehouseStatus);
                    this.showInStoreOnlyCTA();
                } else {
                    this.classList.remove('stock-display--in-store-only');
                    this.hideInStoreRetailExperience();
                    this.setFullyOutOfStockFulfillmentState(variantId, warehouseStatus);
                    this.showOutOfStockCTA();
                }

                this.updateBackInStockForm(variantId, warehouseStatus);
                this.reCalculateAccordionHeight();
                return;
            }

            this.classList.remove('stock-display--in-store-only');
            this.hideBackInStockPanel();
            this.setOnlineFulfillmentVisible(true);
            this.setOnlineFulfillmentTabsVisible(true);

            if (this.clickCollectTabElement) {
                this.toggleShow(this.clickCollectTabElement);
                this.updateClickCollectTabState(clickCollectAvailable);
            }

            this.updateBackInStockForm(variantId, warehouseStatus);

            if (!this.initialDeliveryStateSet) {
                this.initialDeliveryStateSet = true;

                if (!deliveryAvailable && clickCollectAvailable) {
                    this.switchToTab('click-collect');
                } else {
                    this.switchToTab('delivery');
                }
            }

            this.reCalculateAccordionHeight();
        }

        async fetchProductAndLocationData(productId) {
            const url = `/apps/datajet/task/${this.stockDisplayQueryId}`;
            const payload = { productId: String(productId) };

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });

                const responseJson = await response.json();

                if (response.ok && responseJson?.data?.product && responseJson?.data?.locations?.edges?.length) {
                    return responseJson.data;
                }

                console.error('Invalid Datajet response structure:', responseJson);
                return {};
            } catch (error) {
                console.error('Datajet fetch error:', error);
                return {};
            }
        }

        async getVariantAvailabilityByLocationId(variantId, locationId) {
            await this.loadProductAvailability(this.currentProductId);
            const variantData = this.getVariantInventory(variantId);
            const locationKey = locationId
                ? this.normalizeLocationGid(locationId)
                : '';

            if (!variantData) {
                return {
                    storeStockStatus: 'out-of-stock',
                    warehouseStockStatus: 'out-of-stock',
                    clickCollectStatus: 'unavailable',
                };
            }

            const onlineStoreLocation = Object.values(variantData.locations || {}).find((loc) => (
                loc.isWarehouse === true
            ));

            const storeLocationData = locationKey
                ? this.getLocationInventory(variantData, locationKey)
                : null;
            const isProductSoldOut = this.isProductSoldOut;    

            const getWarehouseStatus = (warehouseLocation) => {
                if (!warehouseLocation) return 'out-of-stock';
                const canShip = warehouseLocation.warehouseEnable
                    && (warehouseLocation.warehouseAvailable ?? 0) > 0;
                return canShip ? 'in-stock' : 'out-of-stock';
            };

            if (!storeLocationData) {
                return {
                    storeStockStatus: isProductSoldOut ? 'out-of-stock' : '',
                    warehouseStockStatus: isProductSoldOut ? 'out-of-stock' : getWarehouseStatus(onlineStoreLocation),
                    clickCollectStatus: 'unavailable'
                };
            }

            return {
                ...storeLocationData,
                storeStockStatus: isProductSoldOut ? 'out-of-stock' : storeLocationData.storeStockStatus,
                warehouseStockStatus: isProductSoldOut ? 'out-of-stock' : getWarehouseStatus(onlineStoreLocation),
                clickCollectStatus: isProductSoldOut ? 'unavailable' : storeLocationData.clickCollectStatus
            };
        }


        async loadProductAvailability(productId) {
            if (this.productAvailabilityCache) return this.productAvailabilityCache;

            if (!this.productAvailabilityPromise) {
                this.productAvailabilityPromise = this.buildProductAvailabilityFromDatajet(productId)
                    .finally(() => {
                        this.productAvailabilityPromise = null;
                    });
            }

            return this.productAvailabilityPromise;
        }

        async buildProductAvailabilityFromDatajet(productId) {
            const response = await this.fetchProductAndLocationData(productId);
            const { product, locations } = response;

            const productTags = Array.isArray(product?.tags)
                ? product.tags
                : (typeof product?.tags === 'string'
                    ? product.tags.split(',').map(tag => tag.trim()).filter(Boolean)
                    : []);
            this.isProductSoldOut = this.isProductSoldOut || productTags.includes('product-sold-out');
            
            if (!product || !locations?.edges?.length) {
                console.error('Stock display: missing product or location data from Datajet');
                return {};
            }

            this.style.removeProperty('display');

            product.variants.edges.forEach(({ node: variant }) => {
                const variantId = this.normalizeVariantGid(variant.id);
                const hideStockDisplay = variant.hideStockDisplay?.value ?? null;
                const locationsMap = {};
                let totalWarehouseAvailable = 0;
                let totalStoreAvailable = 0;
                let variantAvailableForSale = variant.availableForSale;

                variant.inventoryItem.inventoryLevels.edges.forEach(({ node: level }) => {
                    const loc = level.location;
                    const locationId = this.normalizeLocationGid(loc.id);
                    const availableQuantity = level.quantities.find(q => q.name === 'available')?.quantity ?? 0;

                    if (!locationsMap[locationId]) {
                        locationsMap[locationId] = {
                            name: loc.name,
                            frontEndName: loc.storeFrontendName?.value || loc.store_frontend_name?.value || loc.name,
                            address: this.normalizeAddressObject(loc.address || null),
                            storeHidden: loc.storeHidden?.value === 'true' || loc.hide_store?.value === 'true',
                            enableForPickup: loc.enableForPickup?.value === 'true' || loc.enable_for_pickup?.value === 'true',
                            storeEnable: loc.storeStockAvailability?.value === 'true' || loc.store_stock_visibility?.value === 'true',
                            warehouseEnable: loc.warehouseStockAvailability?.value === 'true' || loc.warehouse_stock_visibility?.value === 'true',
                            inStockThreshold: parseInt(loc.inStockThreshold?.value) ?? 0,
                            outOfStockThreshold: parseInt(loc.outOfStockThreshold?.value) ?? 0,
                            storeAvailable: 0,
                            warehouseAvailable: 0,
                            totalAvailable: 0,
                            storeStockStatus: null,
                            warehouseStockStatus: 'out-of-stock',
                            isWarehouse: this.isWarehouseLocation(loc)
                        };
                    }

                    const store = locationsMap[locationId];
                    store.totalAvailable += availableQuantity;

                    if (!store.address && loc.address) {
                        store.address = this.normalizeAddressObject(loc.address);
                    }

                    if (store.storeEnable && !store.isWarehouse) {
                        store.storeAvailable += availableQuantity;
                        totalStoreAvailable += availableQuantity;
                    }

                    if (store.warehouseEnable) {
                        store.warehouseAvailable += availableQuantity;
                        totalWarehouseAvailable += availableQuantity;
                    }

                    store.storeStockStatus = store.storeAvailable > 0 ? 'available' : 'unavailable';
                    store.warehouseStockStatus = store.warehouseAvailable > 0 ? 'available' : 'unavailable';
                    store.clickCollectStatus =
                        (this.blockClickCollect || !store.storeEnable || !store.enableForPickup || store.totalAvailable <= 0) ? 'unavailable' : 'available';
                    if (hideStockDisplay === 'true') {
                        store.storeStockStatus = 'unavailable';
                    }
                });

                locations.edges.forEach(({ node }) => {
                    const locationId = this.normalizeLocationGid(node.id);
                    if (!locationsMap[locationId]) {
                        locationsMap[locationId] = {
                            name: node.name,
                            frontEndName: node.storeFrontendName?.value || node.store_frontend_name?.value || node.name,
                            address: this.normalizeAddressObject(node.address || null),
                            storeHidden: node.storeHidden?.value === 'true' || node.hide_store?.value === 'true',
                            enableForPickup: node.enableForPickup?.value === 'true' || node.enable_for_pickup?.value === 'true',
                            storeEnable: node.storeStockAvailability?.value === 'true' || node.store_stock_visibility?.value === 'true',
                            warehouseEnable: node.warehouseStockAvailability?.value === 'true' || node.warehouse_stock_visibility?.value === 'true',
                            inStockThreshold: parseInt(node.inStockThreshold?.value) ?? 0,
                            outOfStockThreshold: parseInt(node.outOfStockThreshold?.value) ?? 0,
                            storeAvailable: 0,
                            warehouseAvailable: 0,
                            totalAvailable: 0,
                            storeStockStatus: 'out-of-stock',
                            warehouseStockStatus: 'out-of-stock',
                            isWarehouse: this.isWarehouseLocation(node),
                            clickCollectStatus: 'unavailable'
                        };
                    } else if (!locationsMap[locationId].address && node.address) {
                        locationsMap[locationId].address = this.normalizeAddressObject(node.address);
                    }
                });

                if (this.isProductSoldOut) {
                    Object.values(locationsMap).forEach(location => {
                        location.storeStockStatus = 'out-of-stock';
                        location.warehouseStockStatus = 'out-of-stock';
                        location.clickCollectStatus = 'unavailable';
                    });
                    totalStoreAvailable = 0;
                    totalWarehouseAvailable = 0;
                }

                this.inventoryByVariantId[variantId] = {
                    hideStockDisplay,
                    totalStoreAvailable,
                    totalWarehouseAvailable,
                    locations: locationsMap
                };
            });

            this.locationsList = locations.edges.map(edge => edge.node);
            this.datajetLocations = locations;
            this.mergeAddressesFromLocationsList();
            this.productAvailabilityCache = this.inventoryByVariantId;
            return this.productAvailabilityCache;
        }

        normalizeAddressObject(addressLike) {
            if (!addressLike) return null;

            if (addressLike.address1 || addressLike.city || addressLike.formatted) {
                return addressLike;
            }

            if (addressLike.address_1 || addressLike.address_2 || addressLike.city) {
                return {
                    address1: addressLike.address_1 || addressLike.address1 || '',
                    address2: addressLike.address_2 || addressLike.address2 || '',
                    city: addressLike.city || '',
                    province: addressLike.province || addressLike.province_code || '',
                    zip: addressLike.zip || addressLike.postal_code || '',
                    country: addressLike.country || '',
                    formatted: addressLike.formatted,
                };
            }

            return null;
        }

        resolveLocationAddress(location, inventory, locationId) {
            const normalizedId = locationId ? this.normalizeLocationGid(locationId) : '';
            const candidates = [
                location?.address,
                inventory?.address,
                normalizedId ? this.findLocationById(normalizedId)?.address : null,
            ];

            for (const candidate of candidates) {
                const normalized = this.normalizeAddressObject(candidate);

                if (normalized && (normalized.address1 || normalized.city || normalized.formatted)) {
                    return normalized;
                }
            }

            return null;
        }

        mergeAddressesFromLocationsList() {
            (this.locationsList || []).forEach((location) => {
                const address = this.resolveLocationAddress(location, null, location.id);
                if (!address) return;

                const locationId = this.normalizeLocationGid(location.id);

                Object.values(this.inventoryByVariantId).forEach((variantInventory) => {
                    const inventory = variantInventory.locations?.[locationId];
                    if (!inventory) return;

                    if (!inventory.address) {
                        inventory.address = address;
                    }
                });
            });
        }

        formatStoreAddress(address) {
            if (!address) return '';

            if (address.formatted) {
                return Array.isArray(address.formatted)
                    ? address.formatted.filter(Boolean).join(', ')
                    : address.formatted;
            }

            return [
                address.address1,
                address.address2,
                address.city,
                address.province,
                address.zip,
                address.country,
            ].filter(Boolean).join(', ');
        }

        formatStoreAddressLines(address) {
            if (!address) return [];

            if (address.formatted) {
                if (Array.isArray(address.formatted)) {
                    return address.formatted.filter(Boolean);
                }

                return String(address.formatted)
                    .split('\n')
                    .map((line) => line.trim())
                    .filter(Boolean);
            }

            const lines = [];

            if (address.address1) lines.push(address.address1);
            if (address.address2) lines.push(address.address2);

            const cityLine = [
                address.city,
                [address.province, address.zip].filter(Boolean).join(' '),
            ].filter(Boolean).join(', ');

            if (cityLine) lines.push(cityLine);

            return lines;
        }

        getStoreAddressDisplay(location, inventory, locationId) {
            const address = this.resolveLocationAddress(location, inventory, locationId);

            return this.formatStoreAddressLines(address).join('\n');
        }

        getLocationSubtitle(location, displayName) {
            if (!location) return '';

            const addressText = this.getStoreAddressDisplay(location);
            const hasStreetAddress = Boolean(
                location.address?.address1 ||
                location.address?.address2 ||
                location.address?.city
            );

            if (hasStreetAddress && addressText) {
                return addressText;
            }

            if (location.name && location.name !== displayName) {
                return location.name;
            }

            return addressText;
        }

        getLocationDisplayName(location) {
            if (!location) return '';
            return location.storeFrontendName?.value || location.name || '';
        }

        isPickupEnabled(location) {
            return location?.enableForPickup?.value === 'true'
                || location?.enable_for_pickup?.value === 'true';
        }

        isWarehouseLocation(location) {
            if (!location) return false;
            return location.isWarehouse?.value === 'true'
                || location.is_default_warehouse?.value === 'true';
        }

        normalizeVariantGid(variantId) {
            if (!variantId) return '';
            const id = String(variantId);
            if (id.startsWith('gid://shopify/ProductVariant/')) {
                return id;
            }
            return `gid://shopify/ProductVariant/${id}`;
        }

        normalizeLocationGid(locationId) {
            if (!locationId) return '';
            const id = String(locationId).replace('gid://shopify/Location/', '');
            return `gid://shopify/Location/${id}`;
        }

        findLocationById(locationId) {
            const normalizedId = this.normalizeLocationGid(locationId);
            return (this.locationsList || []).find((location) => (
                this.normalizeLocationGid(location.id) === normalizedId
            ));
        }

        getLocationInventory(variantInventory, locationId) {
            if (!variantInventory?.locations || !locationId) return null;

            const normalizedId = this.normalizeLocationGid(locationId);
            if (variantInventory.locations[normalizedId]) {
                return variantInventory.locations[normalizedId];
            }

            const numericId = normalizedId.replace('gid://shopify/Location/', '');
            const matchedEntry = Object.entries(variantInventory.locations).find(([key]) => (
                key.endsWith(`/${numericId}`)
            ));

            return matchedEntry?.[1] ?? null;
        }

        isRetailLocation(location) {
            if (!location) return false;
            if (this.isWarehouseLocation(location)) return false;
            if (location.storeHidden?.value === 'true' || location.hide_store?.value === 'true') return false;
            return true;
        }

        isStoreEligibleForModal(location) {
            if (!location) return false;
            if (this.isWarehouseLocation(location)) return false;
            if (location.storeHidden?.value === 'true' || location.hide_store?.value === 'true') return false;
            const storeStockEnabled = location.storeStockAvailability?.value === 'true'
                || location.store_stock_visibility?.value === 'true';
            if (!storeStockEnabled) return false;
            if (!this.isPickupEnabled(location)) return false;
            return true;
        }

        isStoreEligibleForInStorePanel(location) {
            return this.isRetailLocation(location);
        }

        getVariantInventory(variantId) {
            const normalizedId = this.normalizeVariantGid(variantId);

            if (this.inventoryByVariantId[normalizedId]) {
                return this.inventoryByVariantId[normalizedId];
            }

            const numericId = String(variantId).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
            const matchedEntry = Object.entries(this.inventoryByVariantId).find(([key]) => (
                key.endsWith(`/${numericId}`)
            ));

            return matchedEntry?.[1];
        }

        getProductForms() {
            return Array.from(document.querySelectorAll('form[action="/cart/add"]'));
        }

        upsertHiddenFormInput(form, elementId, fieldName, value) {
            if (!form) return;

            let input = form.querySelector(`#${elementId}`);
            if (!input) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.id = elementId;
                input.name = fieldName;
                form.appendChild(input);
            }

            input.value = value;
        }

        removePickupFormFields(form) {
            if (!form) return;

            form.querySelector('#ispickupstore')?.remove();
            form.querySelector('#pickup-variant-id')?.remove();
            form.querySelector('#pickup-quantity')?.remove();
        }

        syncPickupFormFields({ buttonText, shouldDisable, isPickupMode, isPickupOnly }) {
            this.getProductForms().forEach((productForm) => {
                this.removePickupFormFields(productForm);

                if (!isPickupMode) return;

                // _is_cc should only be "Yes" when the item can't be delivered at
                // all (pickup is the only fulfillment option), not just because the
                // shopper happens to be viewing the Click & Collect tab.
                if (isPickupOnly) {
                    this.upsertHiddenFormInput(
                        productForm,
                        'ispickupstore',
                        'properties[_is_cc]',
                        'Yes'
                    );
                }

                if (this.currentVariantId) {
                    this.upsertHiddenFormInput(
                        productForm,
                        'pickup-variant-id',
                        'id',
                        String(this.currentVariantId)
                    );
                }

                this.upsertHiddenFormInput(productForm, 'pickup-quantity', 'quantity', '1');
            });

            this.setAddToCartButtonLabel(buttonText);
            this.setAddToCartButtonsDisabled(shouldDisable);
        }

        isRetailInventoryLocation(inventory, location) {
            if (!inventory || inventory.isWarehouse) return false;
            if (inventory.storeHidden) return false;
            if (location) return this.isRetailLocation(location);
            return true;
        }

        getRetailStoreEntries(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            if (!variantInventory?.locations) return [];

            const entries = [];
            const seen = new Set();

            const addEntry = (location, inventory, locationId) => {
                if (!inventory || !locationId || seen.has(locationId)) return;
                if (!this.isRetailInventoryLocation(inventory, location)) return;

                seen.add(locationId);
                entries.push({ location, inventory, locationId });
            };

            (this.locationsList || []).forEach((location) => {
                const locationId = this.normalizeLocationGid(location.id);
                addEntry(location, this.getLocationInventory(variantInventory, locationId), locationId);
            });

            Object.entries(variantInventory.locations).forEach(([locationId, inventory]) => {
                const location = this.findLocationById(locationId);
                addEntry(location, inventory, this.normalizeLocationGid(locationId));
            });

            return entries;
        }

        getLocationQuantityForInStore(inventory) {
            if (!inventory) return 0;

            if (inventory.storeEnable) {
                return Math.max(inventory.storeAvailable ?? 0, inventory.totalAvailable ?? 0);
            }

            return inventory.totalAvailable ?? 0;
        }

        hasRetailStoreStock(variantId) {
            if (this.isProductSoldOut) return false;

            const variantInventory = this.getVariantInventory(variantId);
            if (!variantInventory?.locations) {
                return this.blockClickCollect && this.variantInventoryQuantity > 0;
            }

            const hasStockInRetailEntries = this.getInStoreAvailabilityEntries(variantId).some(
                ({ inventory }) => this.getLocationQuantityForInStore(inventory) > 0
            );

            if (hasStockInRetailEntries) {
                return true;
            }

            return Object.values(variantInventory.locations).some((inventory) => {
                if (!inventory || inventory.isWarehouse || inventory.storeHidden) return false;
                return (inventory.totalAvailable ?? 0) > 0;
            });
        }

        hasOnlyWarehouseStock(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            if (!variantInventory?.locations) return false;

            let warehouseStock = 0;
            let retailStock = 0;

            Object.values(variantInventory.locations).forEach((inventory) => {
                const quantity = this.getLocationQuantityForInStore(inventory);

                if (inventory.isWarehouse) {
                    warehouseStock += inventory.totalAvailable ?? 0;
                    return;
                }

                if (this.isRetailInventoryLocation(inventory)) {
                    retailStock += quantity;
                }
            });

            return warehouseStock > 0 && retailStock === 0;
        }

        shouldShowInStoreButton(variantId, warehouseStatus) {
            if (this.hasOnlyWarehouseStock(variantId)) return false;
            if (!this.hasRetailStoreStock(variantId)) return false;
            if (this.isInStoreOnlyMode(variantId, warehouseStatus)) return false;
            return true;
        }

        isInStorePanelInventory(inventory) {
            if (!inventory || inventory.isWarehouse || inventory.storeHidden) return false;

            return inventory.storeEnable || (inventory.totalAvailable ?? 0) > 0;
        }

        isInStorePanelLocation(location) {
            if (!location) return true;
            if (this.isWarehouseLocation(location)) return false;

            return location.storeHidden?.value !== 'true' && location.hide_store?.value !== 'true';
        }

        getInStoreAvailabilityEntries(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            if (!variantInventory?.locations) return [];

            const seen = new Set();
            const entries = [];

            const addEntry = (location, inventory, locationId) => {
                const normalizedId = this.normalizeLocationGid(locationId);
                if (!inventory || seen.has(normalizedId)) return;
                if (!this.isInStorePanelInventory(inventory)) return;
                if (location && !this.isInStorePanelLocation(location)) return;

                seen.add(normalizedId);
                entries.push({ location, inventory, locationId: normalizedId });
            };

            Object.entries(variantInventory.locations).forEach(([locationId, inventory]) => {
                addEntry(this.findLocationById(locationId), inventory, locationId);
            });

            (this.locationsList || []).forEach((location) => {
                const locationId = this.normalizeLocationGid(location.id);
                addEntry(location, this.getLocationInventory(variantInventory, locationId), locationId);
            });

            return entries;
        }

        async ensureProductAvailabilityLoaded() {
            if (this.getVariantInventory(this.currentVariantId)?.locations) {
                return true;
            }

            this.productAvailabilityCache = null;
            this.productAvailabilityPromise = null;
            await this.loadProductAvailability(this.currentProductId);

            return Boolean(this.getVariantInventory(this.currentVariantId)?.locations);
        }

        getInStorePanelStores(variantId) {
            return this.getInStoreAvailabilityEntries(variantId)
                .map(({ location, inventory, locationId }) => {
                    const quantity = this.getLocationQuantityForInStore(inventory);
                    const displayName = location
                        ? this.getLocationDisplayName(location)
                        : (inventory.frontEndName || inventory.name || 'Store');

                    return {
                        location,
                        locationId,
                        displayName,
                        province: location
                            ? this.normalizeProvince(location.address?.province || '')
                            : this.normalizeProvince(inventory.address?.province || ''),
                        address: this.getStoreAddressDisplay(location, inventory, locationId),
                        subtitle: this.getStoreAddressDisplay(location, inventory, locationId),
                        isInStock: quantity > 0,
                        directionsUrl: this.getDirectionsUrl(location, inventory),
                    };
                })
                .sort((a, b) => {
                    if (a.isInStock !== b.isInStock) {
                        return a.isInStock ? -1 : 1;
                    }
                    return a.displayName.localeCompare(b.displayName);
                });
        }

        getDirectionsUrl(location, inventory) {
            const addressSource = location?.address || inventory?.address;
            const displayName = location
                ? this.getLocationDisplayName(location)
                : (inventory?.frontEndName || inventory?.name || '');
            const address = this.formatStoreAddress(addressSource);
            const query = [displayName, address].filter(Boolean).join(', ');

            return query
                ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
                : '';
        }

        updateInStorePanelCopy(variantId, warehouseStatus) {
            if (!this.inStoreTitleElement || !this.inStoreDescriptionElement) return;

            const warehouseAvailable = this.normalizeStatus(warehouseStatus) === 'available';
            const variantInventory = this.getVariantInventory(variantId);
            const hasClickCollectAvailable = variantInventory?.locations
                ? Object.values(variantInventory.locations).some((loc) =>
                    !loc.isWarehouse && loc.clickCollectStatus === 'available'
                )
                : false;

            if (!warehouseAvailable && !hasClickCollectAvailable) {
                this.inStoreTitleElement.textContent = 'Available in store only';
                this.inStoreDescriptionElement.textContent =
                    'Delivery and Click & Collect are currently unavailable for this item. Visit a store to purchase.';
            } else {
                this.inStoreTitleElement.textContent = 'Also available in store';
                this.inStoreDescriptionElement.textContent =
                    'Visit one of the following stores to purchase this item in person.';
            }
        }

        renderInStoreList(variantId) {
            if (!this.inStoreListElement) return;

            const stores = this.getInStorePanelStores(variantId);
            this.inStoreListElement.innerHTML = '';

            stores.forEach((store) => {
                const item = document.createElement('div');
                item.className = 'stock-display__in-store-item';
                item.setAttribute('role', 'listitem');

                const main = document.createElement('div');
                main.className = 'stock-display__in-store-item-main';

                const icon = this.createInStoreStatusIcon(store.isInStock);
                main.appendChild(icon);

                const text = document.createElement('div');
                text.className = 'stock-display__in-store-item-text';

                const name = document.createElement('p');
                name.className = 'stock-display__in-store-item-name';
                name.textContent = store.displayName;
                text.appendChild(name);

                const status = document.createElement('p');
                status.className = `stock-display__in-store-item-status ${store.isInStock ? 'stock-display__in-store-item-status--in-stock' : 'stock-display__in-store-item-status--out-of-stock'}`;
                status.textContent = store.isInStock ? 'In stock' : 'Out of stock';
                text.appendChild(status);

                main.appendChild(text);
                item.appendChild(main);

                if (store.directionsUrl) {
                    const directions = document.createElement('a');
                    directions.className = 'stock-display__in-store-directions';
                    directions.href = store.directionsUrl;
                    directions.target = '_blank';
                    directions.rel = 'noopener noreferrer';
                    directions.textContent = 'Get directions';
                    item.appendChild(directions);
                }

                this.inStoreListElement.appendChild(item);
            });
        }

        createInStoreStatusIcon(isInStock) {
            const selector = isInStock
                ? '.stock-display__panel-icon-state--in-stock'
                : '.stock-display__panel-icon-state--out-of-stock';
            const template = this.querySelector(selector);
            const icon = template ? template.cloneNode(true) : document.createElement('span');

            icon.classList.add('stock-display__in-store-item-icon');
            if (isInStock) {
                icon.classList.add('stock-display__in-store-item-icon--in-stock');
            } else {
                icon.classList.add('stock-display__in-store-item-icon--out-of-stock');
            }

            return icon;
        }

        closeInStorePanel() {
            this.inStorePanelOpen = false;
            this.toggleHide(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'true');
            this.toggleShow(this.checkAvailabilityButton);
            this.checkAvailabilityButton?.setAttribute('aria-expanded', 'false');
        }

        hideInStoreRetailExperience() {
            this.inStorePanelOpen = false;
            this.toggleHide(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'true');
            this.toggleHide(this.checkAvailabilityButton);
            this.toggleHide(this.storeButtonChevronElement);
            this.storeButtonChevronElement?.setAttribute('aria-hidden', 'true');
            this.toggleHide(this.viewStoresButton);
            this.viewStoresButton?.setAttribute('aria-hidden', 'true');
            this.toggleHide(this.storeCheckElement);
        }

        showInStoreOnlyExperience(variantId, warehouseStatus) {
            if (!this.storeCheckElement || !this.inStorePanelElement) return;

            this.toggleShow(this.storeCheckElement);
            this.updateInStorePanelCopy(variantId, warehouseStatus);
            this.closeInStoreAvailabilityModal();
            this.inStorePanelOpen = false;
            this.toggleHide(this.checkAvailabilityButton);
            this.toggleHide(this.storeButtonChevronElement);
            this.storeButtonChevronElement?.setAttribute('aria-hidden', 'true');
            this.toggleShow(this.viewStoresButton);
            this.viewStoresButton?.setAttribute('aria-hidden', 'false');
            this.toggleHide(this.inStoreListElement);
            this.inStoreListElement?.setAttribute('aria-hidden', 'true');
            this.inStoreListElement.innerHTML = '';
            this.toggleShow(this.inStorePanelElement);
            this.inStorePanelElement.setAttribute('aria-hidden', 'false');
        }

        openInStorePanel() {
            if (!this.inStorePanelElement || !this.checkAvailabilityButton) return;

            this.inStorePanelOpen = true;
            this.renderInStoreList(this.currentVariantId);
            this.toggleHide(this.checkAvailabilityButton);
            this.toggleShow(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'false');
            this.checkAvailabilityButton.setAttribute('aria-expanded', 'true');
        }

        getAvailabilityStoreProvinces(variantId) {
            const provinces = new Set();

            this.getInStorePanelStores(variantId).forEach((store) => {
                if (store.province) provinces.add(store.province);
            });

            return Array.from(provinces).sort((a, b) => a.localeCompare(b));
        }

        getFilteredAvailabilityStores(variantId) {
            const stores = this.getInStorePanelStores(variantId);

            if (!this.selectedAvailabilityState) {
                return stores;
            }

            return stores.filter((store) => store.province === this.selectedAvailabilityState);
        }

        getPreferredAvailabilityState(variantId) {
            const currentId = this.currentLocationId || this.currentStoreCookie?.dataId || '';

            if (currentId) {
                const currentStore = this.getInStorePanelStores(variantId).find(
                    (store) => store.locationId === currentId
                );

                if (currentStore?.province) {
                    return currentStore.province;
                }
            }

            const provinces = this.getAvailabilityStoreProvinces(variantId);
            return provinces[0] || '';
        }

        initCustomSelects() {
            if (this.storeStateDropdown) return;

            this.storeStateDropdown = this.createCustomSelect(
                this.storeStateFilterElement,
                (value) => this.handleStateFilterChange(value)
            );
            this.availabilityStateDropdown = this.createCustomSelect(
                this.availabilityStateFilterElement,
                (value) => this.handleAvailabilityStateFilterChange(value)
            );

            if (this.customSelectOutsideClickHandler) return;

            this.customSelectOutsideClickHandler = (event) => {
                if (!event.target.closest('[data-custom-select]')) {
                    this.closeOpenCustomSelects();
                }
            };
            document.addEventListener('click', this.customSelectOutsideClickHandler);
        }

        createCustomSelect(rootElement, onChange) {
            if (!rootElement) return null;

            const trigger = rootElement.querySelector('[data-custom-select-trigger]');
            const valueElement = rootElement.querySelector('[data-custom-select-value]');
            const menu = rootElement.querySelector('[data-custom-select-menu]');
            let currentValue = '';
            let isOpen = false;

            const close = () => {
                if (!isOpen) return;
                isOpen = false;
                rootElement.classList.remove('stock-display__custom-select--open');
                trigger.setAttribute('aria-expanded', 'false');
                menu.classList.add('hide');
            };

            const open = () => {
                if (isOpen) return;
                this.closeOpenCustomSelects(rootElement);
                isOpen = true;
                rootElement.classList.add('stock-display__custom-select--open');
                trigger.setAttribute('aria-expanded', 'true');
                menu.classList.remove('hide');
            };

            const toggle = () => {
                if (isOpen) close();
                else open();
            };

            const renderOptions = (options, selectedValue) => {
                menu.innerHTML = '';
                options.forEach((option) => {
                    const optionElement = document.createElement('li');
                    const isSelected = option === selectedValue;
                    optionElement.className = 'stock-display__custom-select-option';
                    if (isSelected) {
                        optionElement.classList.add('stock-display__custom-select-option--selected');
                    }
                    optionElement.setAttribute('role', 'option');
                    optionElement.setAttribute('data-value', option);
                    optionElement.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                    optionElement.textContent = option;
                    menu.appendChild(optionElement);
                });
            };

            const selectValue = (value, shouldNotify = true) => {
                const hasChanged = value !== currentValue;
                currentValue = value;
                valueElement.textContent = value;
                renderOptions(
                    Array.from(menu.querySelectorAll('[role="option"]')).map(
                        (option) => option.getAttribute('data-value')
                    ),
                    value
                );
                close();

                if (shouldNotify && hasChanged) {
                    onChange?.(value);
                }
            };

            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                toggle();
            });

            menu.addEventListener('click', (event) => {
                const optionElement = event.target.closest('[role="option"]');
                if (!optionElement) return;
                selectValue(optionElement.getAttribute('data-value'));
            });

            trigger.addEventListener('keydown', (event) => {
                if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    open();
                }
            });

            menu.addEventListener('keydown', (event) => {
                const options = Array.from(menu.querySelectorAll('[role="option"]'));
                const currentIndex = options.findIndex(
                    (option) => option.getAttribute('data-value') === currentValue
                );

                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    close();
                    trigger.focus();
                } else if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    const nextOption = options[Math.min(currentIndex + 1, options.length - 1)];
                    if (nextOption) selectValue(nextOption.getAttribute('data-value'));
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    const previousOption = options[Math.max(currentIndex - 1, 0)];
                    if (previousOption) selectValue(previousOption.getAttribute('data-value'));
                } else if (event.key === 'Enter') {
                    event.preventDefault();
                    close();
                }
            });

            return {
                root: rootElement,
                setOptions: (options, selectedValue) => {
                    currentValue = selectedValue || options[0] || '';
                    valueElement.textContent = currentValue;
                    renderOptions(options, currentValue);
                    close();
                },
                close,
                isOpen: () => isOpen,
                getValue: () => currentValue,
            };
        }

        closeOpenCustomSelects(exceptRoot = null) {
            [this.storeStateDropdown, this.availabilityStateDropdown].forEach((dropdown) => {
                if (!dropdown) return;
                if (exceptRoot && dropdown.root === exceptRoot) return;
                dropdown.close();
            });
        }

        closeOpenCustomSelect() {
            let closed = false;

            [this.storeStateDropdown, this.availabilityStateDropdown].forEach((dropdown) => {
                if (!dropdown?.isOpen()) return;
                dropdown.close();
                closed = true;
            });

            return closed;
        }

        updateAvailabilityStateFilterOptions(variantId) {
            if (!this.availabilityStateDropdown) return;

            const provinces = this.getAvailabilityStoreProvinces(variantId);

            if (provinces.length <= 1) {
                this.selectedAvailabilityState = provinces[0] || '';
                this.availabilityStateFilterFieldElement?.classList.add('hide');
                this.availabilityStateFilterFieldElement?.setAttribute('aria-hidden', 'true');
                return;
            }

            this.availabilityStateFilterFieldElement?.classList.remove('hide');
            this.availabilityStateFilterFieldElement?.removeAttribute('aria-hidden');

            if (!this.selectedAvailabilityState || !provinces.includes(this.selectedAvailabilityState)) {
                this.selectedAvailabilityState = this.getPreferredAvailabilityState(variantId);
            }

            this.availabilityStateDropdown.setOptions(provinces, this.selectedAvailabilityState);
        }

        handleAvailabilityStateFilterChange(selectedState) {
            if (!this.availabilityStateDropdown) return;

            this.selectedAvailabilityState = selectedState || this.availabilityStateDropdown.getValue();
            this.renderInStoreAvailabilityModalList();
        }

        renderInStoreAvailabilityModalList({ isLoading = false } = {}) {
            if (!this.inStoreAvailabilityModalListElement) return;

            const listElement = this.inStoreAvailabilityModalListElement;
            listElement.innerHTML = '';

            if (isLoading) {
                listElement.innerHTML = '<p class="stock-display__availability-modal-empty">Loading stores...</p>';
                return;
            }

            const stores = this.getFilteredAvailabilityStores(this.currentVariantId);

            if (!stores.length) {
                const emptyMessage = this.selectedAvailabilityState
                    ? 'No stores available in this state.'
                    : 'No stores available.';
                listElement.innerHTML = `<p class="stock-display__availability-modal-empty">${emptyMessage}</p>`;
                return;
            }

            stores.forEach((store) => {
                const card = document.createElement('div');
                card.className = 'stock-display__availability-modal-card';
                if (!store.isInStock) {
                    card.classList.add('stock-display__availability-modal-card--out-of-stock');
                }
                card.setAttribute('role', 'listitem');

                const header = document.createElement('div');
                header.className = 'stock-display__availability-modal-card-header';

                const name = document.createElement('p');
                name.className = 'stock-display__availability-modal-card-name';
                name.textContent = store.displayName;
                header.appendChild(name);
                card.appendChild(header);

                const body = document.createElement('div');
                body.className = 'stock-display__availability-modal-card-body';

                if (store.address) {
                    const address = document.createElement('p');
                    address.className = 'stock-display__availability-modal-card-address';
                    address.textContent = store.address;
                    body.appendChild(address);
                }

                const status = document.createElement('div');
                status.className = 'stock-display__availability-modal-card-status';

                const dot = document.createElement('span');
                dot.className = `stock-display__availability-modal-card-dot ${store.isInStock ? 'stock-display__availability-modal-card-dot--in-stock' : 'stock-display__availability-modal-card-dot--out-of-stock'}`;
                dot.setAttribute('aria-hidden', 'true');
                status.appendChild(dot);

                const statusText = document.createElement('span');
                statusText.className = 'stock-display__availability-modal-card-status-text';
                statusText.textContent = store.isInStock ? 'In stock' : 'Out of stock';
                status.appendChild(statusText);

                body.appendChild(status);
                card.appendChild(body);
                listElement.appendChild(card);
            });
        }

        portalModalToBody(modalElement) {
            if (!modalElement || modalElement.parentElement === document.body) return;

            document.body.appendChild(modalElement);
        }

        openDrawerModal(modalElement, onOpen) {
            if (!modalElement) return;

            if (!modalElement.classList.contains('hide')) {
                if (modalElement.classList.contains('stock-display__drawer-modal--open')) return;
                modalElement.classList.add('hide');
            }

            this.portalModalToBody(modalElement);
            modalElement.classList.remove('hide');
            document.body.classList.add('popup-open');

            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    modalElement.classList.add('stock-display__drawer-modal--open');
                });
            });

            onOpen?.();
        }

        closeDrawerModal(modalElement, onClose) {
            if (!modalElement || modalElement.classList.contains('hide') || modalElement.dataset.closing === 'true') {
                return;
            }

            modalElement.dataset.closing = 'true';
            modalElement.classList.remove('stock-display__drawer-modal--open');

            const panel = modalElement.querySelector('[class*="modal-panel"]');
            let hasFinished = false;

            const finishClose = () => {
                if (hasFinished) return;
                hasFinished = true;

                if (panel) {
                    panel.removeEventListener('transitionend', handleTransitionEnd);
                }

                modalElement.classList.add('hide');
                delete modalElement.dataset.closing;
                document.body.classList.remove('popup-open');
                onClose?.();
            };

            const handleTransitionEnd = (event) => {
                if (event.target !== panel || event.propertyName !== 'transform') return;
                finishClose();
            };

            if (panel) {
                panel.addEventListener('transitionend', handleTransitionEnd);
            }

            window.setTimeout(finishClose, DRAWER_MODAL_TRANSITION_MS + 50);
        }

        isDrawerModalVisible(modalElement) {
            return Boolean(modalElement && !modalElement.classList.contains('hide'));
        }

        async openInStoreAvailabilityModal(triggerElement) {
            if (!this.inStoreAvailabilityModalElement) return;

            this.inStoreAvailabilityModalTriggerElement = triggerElement || null;
            this.renderInStoreAvailabilityModalList({ isLoading: true });
            this.openDrawerModal(this.inStoreAvailabilityModalElement, () => {
                this.checkAvailabilityButton?.setAttribute('aria-expanded', 'true');
                this.inStoreAvailabilityModalCloseButton?.focus();
            });

            await this.ensureProductAvailabilityLoaded();
            this.updateAvailabilityStateFilterOptions(this.currentVariantId);
            this.renderInStoreAvailabilityModalList();
        }

        closeInStoreAvailabilityModal() {
            if (!this.inStoreAvailabilityModalElement) return;

            this.availabilityStateDropdown?.close();
            this.selectedAvailabilityState = '';

            this.closeDrawerModal(this.inStoreAvailabilityModalElement, () => {
                this.checkAvailabilityButton?.setAttribute('aria-expanded', 'false');

                if (this.inStoreAvailabilityModalTriggerElement) {
                    this.inStoreAvailabilityModalTriggerElement.focus();
                    this.inStoreAvailabilityModalTriggerElement = null;
                }
            });
        }

        inStoreAvailabilityModalEvent() {
            this.inStoreAvailabilityModalCloseButton?.addEventListener('click', () => {
                this.closeInStoreAvailabilityModal();
            });

            this.inStoreAvailabilityModalBackdropElements?.forEach((element) => {
                element.addEventListener('click', () => this.closeInStoreAvailabilityModal());
            });

            document.addEventListener('keydown', (event) => {
                if (
                    event.key === 'Escape'
                    && this.isDrawerModalVisible(this.inStoreAvailabilityModalElement)
                ) {
                    if (this.closeOpenCustomSelect()) {
                        event.preventDefault();
                        return;
                    }
                    this.closeInStoreAvailabilityModal();
                }
            });
        }

        updateInStoreAvailability(variantId, warehouseStatus) {
            const hasRetailStock = this.hasRetailStoreStock(variantId);
            const inStoreOnly = this.isInStoreOnlyMode(variantId, warehouseStatus);
            const showInStoreButton = this.shouldShowInStoreButton(variantId, warehouseStatus);

            if (inStoreOnly && hasRetailStock) {
                this.showInStoreOnlyExperience(variantId, warehouseStatus);
                return;
            }

            if (!showInStoreButton) {
                this.closeInStoreAvailabilityModal();
                this.closeInStorePanel();
                this.hideInStoreRetailExperience();
                return;
            }

            this.toggleShow(this.storeCheckElement);
            this.updateInStorePanelCopy(variantId, warehouseStatus);

            this.closeInStorePanel();

            this.toggleShow(this.checkAvailabilityButton);
            this.toggleShow(this.storeButtonChevronElement);
            this.storeButtonChevronElement?.setAttribute('aria-hidden', 'false');
            this.toggleHide(this.viewStoresButton);
            this.viewStoresButton?.setAttribute('aria-hidden', 'true');
            this.toggleHide(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'true');
            this.checkAvailabilityButton?.setAttribute('aria-expanded', 'false');
        }

        storeCheckEvent() {
            this.checkAvailabilityButton?.addEventListener('click', (event) => {
                event.preventDefault();

                if (!this.shouldShowInStoreButton(this.currentVariantId, this.currentWarehouseStatus)) {
                    return;
                }

                this.openInStoreAvailabilityModal(event.currentTarget);
            });
        }

        viewStoresEvent() {
            this.viewStoresButton?.addEventListener('click', (event) => {
                event.preventDefault();
                this.openInStoreAvailabilityModal(event.currentTarget);
            });
        }

        mapLocationToStoreChoice(location, inventory, currentLocationId) {
            const locationId = location.id.replace('gid://shopify/Location/', '');
            const displayName = this.getLocationDisplayName(location);
            const province = this.normalizeProvince(location.address?.province || '');

            return {
                value: displayName,
                label: displayName,
                customProperties: {
                    id: locationId,
                    province,
                    subtitle: this.getLocationSubtitle(location, displayName),
                    clickCollectStatus: inventory?.clickCollectStatus || 'unavailable',
                    storeStockStatus: inventory?.storeStockStatus || 'unavailable',
                },
                selected: locationId === currentLocationId,
            };
        }

        normalizeProvince(province) {
            if (!province) return '';

            const trimmed = String(province).trim();
            const upper = trimmed.toUpperCase();

            return AU_STATE_NAMES[upper] || trimmed;
        }

        getStoreProvinces() {
            const provinces = new Set();

            this.storeChoicesList.forEach((storeChoice) => {
                const province = storeChoice.customProperties.province;
                if (province) provinces.add(province);
            });

            return Array.from(provinces).sort((a, b) => a.localeCompare(b));
        }

        getFilteredStoreChoices() {
            if (!this.selectedModalState) {
                return this.storeChoicesList;
            }

            return this.storeChoicesList.filter(
                (storeChoice) => storeChoice.customProperties.province === this.selectedModalState
            );
        }

        getPreferredModalState() {
            const currentId = this.currentLocationId || this.currentStoreCookie?.dataId || '';

            if (currentId) {
                const currentChoice = this.storeChoicesList.find(
                    (storeChoice) => storeChoice.customProperties.id === currentId
                );

                if (currentChoice?.customProperties.province) {
                    return currentChoice.customProperties.province;
                }
            }

            const provinces = this.getStoreProvinces();
            return provinces[0] || '';
        }

        updateStateFilterOptions() {
            if (!this.storeStateDropdown) return;

            const provinces = this.getStoreProvinces();

            if (provinces.length <= 1) {
                this.selectedModalState = provinces[0] || '';
                this.storeStateFilterFieldElement?.classList.add('hide');
                this.storeStateFilterFieldElement?.setAttribute('aria-hidden', 'true');
                return;
            }

            this.storeStateFilterFieldElement?.classList.remove('hide');
            this.storeStateFilterFieldElement?.removeAttribute('aria-hidden');

            if (!this.selectedModalState || !provinces.includes(this.selectedModalState)) {
                this.selectedModalState = this.getPreferredModalState();
            }

            this.storeStateDropdown.setOptions(provinces, this.selectedModalState);
        }

        handleStateFilterChange(selectedState) {
            if (!this.storeStateDropdown) return;

            this.selectedModalState = selectedState || this.storeStateDropdown.getValue();

            const filteredChoices = this.getFilteredStoreChoices();
            const pendingStillVisible = filteredChoices.some(
                (storeChoice) => storeChoice.customProperties.id === this.pendingModalStoreId
            );

            if (!pendingStillVisible) {
                this.pendingModalStoreId = '';
            }

            this.renderStoreModalList();
            this.updateStoreModalFooter();
        }

        isClickCollectAvailable(status) {
            return status === 'in-stock' || status === 'available' || status === 'low-in-stock';
        }

        isClickCollectAvailableForLocation(data) {
            if (!data) return false;

            if (this.blockClickCollect) return false;

            const storeAvailable = this.normalizeStatus(data.storeStockStatus) === 'available';
            const clickCollectAvailable = this.isClickCollectAvailable(data.clickCollectStatus);

            return storeAvailable && clickCollectAvailable;
        }

        buildStoreList(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            const locationsMap = variantInventory?.locations || {};
            const currentLocationId = this.currentLocationId || this.currentStoreCookie?.dataId || '';

            if (!this.locationsList?.length) {
                this.storeChoicesList = [];
                this.renderStoreModalList();
                return;
            }

            this.storeChoicesList = this.locationsList
                .filter((location) => this.isStoreEligibleForModal(location))
                .map((location) => this.mapLocationToStoreChoice(
                    location,
                    this.getLocationInventory(variantInventory, location.id),
                    currentLocationId
                ))
                .sort((a, b) => {
                    const aAvailable = this.isClickCollectAvailableForLocation({
                        clickCollectStatus: a.customProperties.clickCollectStatus,
                        storeStockStatus: a.customProperties.storeStockStatus,
                    });
                    const bAvailable = this.isClickCollectAvailableForLocation({
                        clickCollectStatus: b.customProperties.clickCollectStatus,
                        storeStockStatus: b.customProperties.storeStockStatus,
                    });

                    if (aAvailable !== bAvailable) {
                        return aAvailable ? -1 : 1;
                    }

                    return a.label.localeCompare(b.label);
                });

            this.updateStateFilterOptions();
            this.renderStoreModalList();
        }

        renderStoreModalList({ isLoading = false } = {}) {
            if (!this.storeModalListElement) return;

            const listElement = this.storeModalListElement;
            listElement.innerHTML = '';

            if (isLoading) {
                listElement.innerHTML = '<p class="stock-display__store-modal-empty">Loading stores...</p>';
                return;
            }

            const filteredStoreChoices = this.getFilteredStoreChoices();

            if (!filteredStoreChoices.length) {
                const emptyMessage = this.selectedModalState
                    ? 'No stores available in this state.'
                    : 'No stores available for click &amp; collect.';
                listElement.innerHTML = `<p class="stock-display__store-modal-empty">${emptyMessage}</p>`;
                return;
            }

            filteredStoreChoices.forEach((storeChoice) => {
                const isAvailable = this.isClickCollectAvailableForLocation({
                    clickCollectStatus: storeChoice.customProperties.clickCollectStatus,
                    storeStockStatus: storeChoice.customProperties.storeStockStatus,
                });
                const isSelected = storeChoice.customProperties.id === this.pendingModalStoreId;
                const card = document.createElement('button');
                card.type = 'button';
                card.className = 'stock-display__store-modal-card';
                card.setAttribute('role', 'option');
                card.setAttribute('aria-selected', isSelected ? 'true' : 'false');

                if (!isAvailable) {
                    card.classList.add('stock-display__store-modal-card--unavailable');
                    card.disabled = true;
                } else if (isSelected) {
                    card.classList.add('stock-display__store-modal-card--selected');
                    card.addEventListener('click', () => this.selectPendingStore(storeChoice));
                } else {
                    card.addEventListener('click', () => this.selectPendingStore(storeChoice));
                }

                const header = document.createElement('div');
                header.className = 'stock-display__store-modal-card-header';

                const radio = document.createElement('span');
                radio.className = 'stock-display__store-modal-card-radio';
                radio.setAttribute('aria-hidden', 'true');
                header.appendChild(radio);

                const name = document.createElement('p');
                name.className = 'stock-display__store-modal-card-name';
                name.textContent = storeChoice.label;
                header.appendChild(name);
                card.appendChild(header);

                const body = document.createElement('div');
                body.className = 'stock-display__store-modal-card-body';

                const subtitle = storeChoice.customProperties.subtitle;
                if (subtitle) {
                    const address = document.createElement('p');
                    address.className = 'stock-display__store-modal-card-address';
                    address.textContent = subtitle;
                    body.appendChild(address);
                }

                const status = document.createElement('div');
                status.className = 'stock-display__store-modal-card-status';

                const dot = document.createElement('span');
                dot.className = `stock-display__store-modal-card-dot ${isAvailable ? 'stock-display__store-modal-card-dot--in-stock' : 'stock-display__store-modal-card-dot--out-of-stock'}`;
                dot.setAttribute('aria-hidden', 'true');
                status.appendChild(dot);

                const statusText = document.createElement('span');
                statusText.className = 'stock-display__store-modal-card-status-text';
                statusText.textContent = isAvailable ? 'In stock' : 'Out of stock';
                status.appendChild(statusText);

                body.appendChild(status);
                card.appendChild(body);
                listElement.appendChild(card);
            });
        }

        selectPendingStore(storeChoice) {
            if (!storeChoice?.customProperties?.id) return;

            this.pendingModalStoreId = storeChoice.customProperties.id;
            this.renderStoreModalList();
            this.updateStoreModalFooter();
        }

        getPendingStoreChoice() {
            return this.storeChoicesList.find(
                (storeChoice) => storeChoice.customProperties.id === this.pendingModalStoreId
            );
        }

        async fetchCartPickupStore() {
            this.cartPickupStoreId = '';
            this.cartPickupStoreName = '';

            try {
                const response = await fetch('/cart.json');
                const cart = await response.json();

                if (!cart?.item_count) return;

                this.cartPickupStoreId = cart.attributes?._pickup_store_id || '';
                this.cartPickupStoreName = cart.attributes?._pickup_store_name || '';
            } catch (error) {
                console.error('Failed to fetch cart pickup store:', error);
            }
        }

        updateStoreModalFooter() {
            const pendingChoice = this.getPendingStoreChoice();
            const hasPendingSelection = Boolean(pendingChoice);
            const canConfirm = hasPendingSelection && this.isClickCollectAvailableForLocation({
                clickCollectStatus: pendingChoice.customProperties.clickCollectStatus,
                storeStockStatus: pendingChoice.customProperties.storeStockStatus,
            });
            const showStoreChangeWarning = canConfirm
                && Boolean(this.cartPickupStoreId)
                && this.pendingModalStoreId !== this.cartPickupStoreId;

            if (showStoreChangeWarning) {
                this.toggleShow(this.storeModalFooterWarningElement);
                this.storeModalFooterWarningElement?.setAttribute('aria-hidden', 'false');

                if (this.storeModalWarningDetailElement) {
                    const cartStoreName = this.cartPickupStoreName || 'another store';
                    this.storeModalWarningDetailElement.textContent = `You have click & collect items in your cart from ${cartStoreName}. Switching to another store will update those items.`;
                }
            } else {
                this.toggleHide(this.storeModalFooterWarningElement);
                this.storeModalFooterWarningElement?.setAttribute('aria-hidden', 'true');
            }

            if (this.storeModalConfirmButton) {
                this.storeModalConfirmButton.disabled = !canConfirm;
            }
        }

        confirmPendingStore() {
            const pendingChoice = this.getPendingStoreChoice();
            if (!pendingChoice) return;

            this.selectStore(pendingChoice);
        }

        initializeStoreModalSelection() {
            const currentId = this.currentLocationId || this.currentStoreCookie?.dataId || '';
            let pendingId = '';

            if (currentId) {
                const currentChoice = this.storeChoicesList.find(
                    (storeChoice) => storeChoice.customProperties.id === currentId
                );

                if (currentChoice && this.isClickCollectAvailableForLocation({
                    clickCollectStatus: currentChoice.customProperties.clickCollectStatus,
                    storeStockStatus: currentChoice.customProperties.storeStockStatus,
                })) {
                    pendingId = currentId;
                }
            }

            this.pendingModalStoreId = pendingId;
            this.selectedModalState = this.getPreferredModalState();
            this.updateStateFilterOptions();
            this.renderStoreModalList();
            this.updateStoreModalFooter();
        }

        async selectStore(storeChoice) {
            if (!storeChoice?.customProperties) return;

            const storeData = {
                name: storeChoice.value,
                dataId: storeChoice.customProperties.id,
                province: storeChoice.customProperties.province,
                storeStockAvailability: storeChoice.customProperties.storeStockStatus,
            };

            this.closeStoreModal();
            this.pendingModalStoreId = '';
            this.setCookie('currentStore', storeData, 30);
            this.currentStoreCookie = this.getCookie('currentStore');

            // Await store/cart attribute sync before recalculating the add-to-cart CTA,
            // otherwise hasStoreSelected()/activeTab can be evaluated against stale state
            // and the "Pickup in store" label + _is_cc property never get applied.
            await this.setCurrentStore();
            await this.setStockAvailability(this.currentVariantId, storeData.dataId);
            this.buildStoreList(this.currentVariantId);

            document.dispatchEvent(new CustomEvent('storeLocationChanged', {
                detail: storeData,
            }));
        }

        openStoreModal(triggerElement) {
            if (!this.storeModalElement) return;

            this.storeModalTriggerElement = triggerElement || null;

            const initModalContent = () => {
                this.buildStoreList(this.currentVariantId);
                this.initializeStoreModalSelection();
                this.storeModalCloseButton?.focus();
            };

            const cartPromise = this.fetchCartPickupStore();

            if (this.productAvailabilityCache) {
                cartPromise.then(() => {
                    this.openDrawerModal(this.storeModalElement, initModalContent);
                });
                return;
            }

            this.pendingModalStoreId = '';
            this.renderStoreModalList({ isLoading: true });
            this.updateStoreModalFooter();
            this.openDrawerModal(this.storeModalElement, () => {
                this.storeModalCloseButton?.focus();
            });

            Promise.all([
                this.loadProductAvailability(this.currentProductId),
                cartPromise,
            ]).then(initModalContent);
        }

        closeStoreModal() {
            if (!this.storeModalElement) return;

            this.storeStateDropdown?.close();
            this.pendingModalStoreId = '';
            this.selectedModalState = '';
            this.updateStoreModalFooter();

            this.closeDrawerModal(this.storeModalElement, () => {
                if (this.storeModalTriggerElement) {
                    this.storeModalTriggerElement.focus();
                    this.storeModalTriggerElement = null;
                }
            });
        }

        storeModalEvent() {
            this.selectStoreButton?.addEventListener('click', (event) => {
                event.preventDefault();
                this.openStoreModal(event.currentTarget);
            });

            this.changeStoreButton?.addEventListener('click', (event) => {
                event.preventDefault();
                this.openStoreModal(event.currentTarget);
            });

            this.storeModalCloseButton?.addEventListener('click', () => this.closeStoreModal());
            this.storeModalDismissButton?.addEventListener('click', () => this.closeStoreModal());
            this.storeModalBackdropElement?.addEventListener('click', () => this.closeStoreModal());
            this.storeModalConfirmButton?.addEventListener('click', () => this.confirmPendingStore());

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && this.isDrawerModalVisible(this.storeModalElement)) {
                    if (this.closeOpenCustomSelect()) {
                        event.preventDefault();
                        return;
                    }
                    this.closeStoreModal();
                }
            });
        }

        async setCurrentStore() {
            if (this.currentStoreCookie) {
                const location = this.locationsList.find(loc => loc.id.replace('gid://shopify/Location/', '') === this.currentStoreCookie.dataId);

                if (!location || !this.isPickupEnabled(location)) {
                    this.setCookie('currentStore', null, -1);
                    this.currentStoreCookie = null;
                    this.setClickCollectPanelWhenNoStore();
                    this.currentLocationId = '';
                    return;
                }

                const displayName = this.getLocationDisplayName(location) || this.currentStoreCookie.name;

                await this.updateAttributeCart('_pickup_store_name', displayName);
                await this.updateAttributeCart('_pickup_store_id', this.currentStoreCookie.dataId);

                this.storeNameElement.textContent = displayName;
                this.currentLocationId = this.currentStoreCookie.dataId;
                this.setClickCollectPanelWithStore(displayName);
                if (this.hasClickCollectAvailableAnywhere(this.currentVariantId)) {
                    this.switchToTab('click-collect');
                }
            } else {
                this.setClickCollectPanelWhenNoStore();
                this.currentLocationId = '';
            }
        }

        async updateAttributeCart(key, value) {
            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        attributes: {
                            [key]: value || '',
                        },
                    }),
                });

                const data = await response.json();
                console.log('✅ Cart attribute updated:', data.attributes);
                return data;
            } catch (error) {
                console.error('❌ Error updating pickup store attribute:', error);
            }
        }

        setStockStatusHtml(element, status) {
            this.setPanelStatus(
                element,
                this.deliveryIconElement,
                status,
                'Free standard delivery for all S/PLUS members',
                this.outOfStockText
            );
        }

        setClickCollectStatusHtml(data, storeDisplayName) {
            const isAvailable = this.isClickCollectAvailableForLocation(data);

            if (storeDisplayName && this.selectedStoreNameElement) {
                this.selectedStoreNameElement.textContent = storeDisplayName;
            }

            if (this.selectedStoreBadgeElement) {
                this.selectedStoreBadgeElement.textContent = isAvailable ? 'In stock' : 'Out of stock';
                this.selectedStoreBadgeElement.classList.toggle('stock-display__store-selected-badge--success', isAvailable);
                this.selectedStoreBadgeElement.classList.toggle('stock-display__store-selected-badge--error', !isAvailable);
            }

            if (this.selectedStoreReadyElement) {
                this.selectedStoreReadyElement.textContent = isAvailable ? 'Ready in 2 hours' : '';
            }

            if (this.storeSelectedContentElement) {
                this.storeSelectedContentElement.classList.toggle('stock-display__store-selected-content--unavailable', !isAvailable);
            }
        }

        normalizeStatus(status) {
            if (!status) return 'unavailable';
            if (status === 'in-stock' || status === 'available' || status === 'low-in-stock') {
                return 'available';
            }
            return 'unavailable';
        }

        getStoreDisplayName(locationId) {
            if (!locationId) return this.storeNameElement?.textContent || '';

            const location = this.findLocationById(locationId);

            return this.getLocationDisplayName(location) || this.storeNameElement?.textContent || '';
        }
        hasStoreSelected() {
            return !!(this.currentLocationId || this.currentStoreCookie?.dataId);
        }

        requiresStoreSelection(warehouseStatus) {
            const clickCollectAvailable = this.hasClickCollectAvailableAnywhere(this.currentVariantId);
            const deliveryAvailable = this.isDeliveryAvailable(warehouseStatus);

            if (!clickCollectAvailable || this.hasStoreSelected()) return false;
            if (!deliveryAvailable) return true;

            return this.activeTab === 'click-collect';
        }

        refreshAddToCartButton() {
            this.updateAddToCartButtonText({
                warehouseStockStatus: this.currentWarehouseStatus,
            });
        }

        shouldShowInStoreOnlyCTA(variantId, warehouseStatus) {
            if (this.isProductSoldOut) return false;

            if (this.classList.contains('stock-display--in-store-only')) {
                return true;
            }

            return this.isAvailableInStoreOnly(
                variantId ?? this.currentVariantId,
                warehouseStatus ?? this.currentWarehouseStatus
            );
        }

        setAddToCartButtonLabel(label) {
            document.querySelectorAll('[data-add-to-cart-text]').forEach((element) => {
                element.textContent = label;
            });
        }

        setAddToCartButtonsDisabled(isDisabled) {
            document.querySelectorAll(
                'button[data-add-to-cart], button[name="add"].product-form__submit, [data-section-type="product"] button.product-form__submit'
            ).forEach((button) => {
                button.classList.remove('hide');
                button.removeAttribute('aria-hidden');

                if (isDisabled) {
                    button.setAttribute('disabled', 'disabled');
                    button.disabled = true;
                } else {
                    button.removeAttribute('disabled');
                    button.disabled = false;
                }
            });
        }

        shouldShowOutOfStockCTA(variantId, warehouseStatus) {
            if (this.isProductSoldOut) return true;

            if (this.shouldShowInStoreOnlyCTA(variantId, warehouseStatus)) {
                return false;
            }

            const clickCollectAvailable = this.hasClickCollectAvailableAnywhere(
                variantId ?? this.currentVariantId
            );
            const deliveryAvailable = this.isDeliveryAvailable(
                warehouseStatus ?? this.currentWarehouseStatus
            );

            if (deliveryAvailable || clickCollectAvailable) {
                return false;
            }

            return this.isFullyOutOfStockEverywhere(
                variantId ?? this.currentVariantId,
                warehouseStatus ?? this.currentWarehouseStatus
            );
        }

        showOutOfStockCTA() {
            this.clearScheduledDetachProductFormActions();
            this.restoreProductFormActions();

            const outOfStockLabel = this.outOfStockText || 'Out of Stock';

            const applyOutOfStockCTA = () => {
                if (!this.shouldShowOutOfStockCTA()) {
                    return;
                }

                this.setAddToCartButtonLabel(outOfStockLabel);
                this.setAddToCartButtonsDisabled(true);
            };

            applyOutOfStockCTA();
            [100, 500, 1000, 2000].forEach((delay) => {
                window.setTimeout(applyOutOfStockCTA, delay);
            });
        }

        showInStoreOnlyCTA() {
            this.clearScheduledDetachProductFormActions();
            this.restoreProductFormActions();

            const applyInStoreOnlyCTA = () => {
                if (!this.shouldShowInStoreOnlyCTA()) {
                    return;
                }

                this.setAddToCartButtonLabel('Available in store only');
                this.setAddToCartButtonsDisabled(true);
            };

            applyInStoreOnlyCTA();
            [100, 500, 1000, 2000].forEach((delay) => {
                window.setTimeout(applyInStoreOnlyCTA, delay);
            });
        }

        clearScheduledDetachProductFormActions() {
            this.detachProductFormTimeouts.forEach((timeoutId) => {
                window.clearTimeout(timeoutId);
            });
            this.detachProductFormTimeouts = [];
        }

        detachProductFormActions() {
            document.querySelectorAll('.product__details .product-form__actions, .product-sticky .product-form__actions').forEach((actions) => {
                const alreadyDetached = this.detachedProductFormActions.some((entry) => entry.node === actions);
                if (alreadyDetached) return;

                this.detachedProductFormActions.push({
                    node: actions,
                    parent: actions.parentElement,
                    nextSibling: actions.nextSibling,
                });
                actions.remove();
            });
        }

        restoreProductFormActions() {
            if (!this.detachedProductFormActions.length) return;

            this.detachedProductFormActions.forEach(({ node, parent, nextSibling }) => {
                if (!parent) return;
                parent.insertBefore(node, nextSibling);
            });

            this.detachedProductFormActions = [];
        }

        updateAddToCartButtonText(data) {
            document.querySelector("#ispickupstore")?.remove();

            if (this.isProductSoldOut) {
                this.updateDynamicCheckoutVisibility(true);
                this.showOutOfStockCTA();
                return;
            }

            const rawWarehouseStatus = data.warehouseStockStatus || this.currentWarehouseStatus || 'out-of-stock';

            if (this.shouldShowInStoreOnlyCTA(this.currentVariantId, rawWarehouseStatus)) {
                this.updateDynamicCheckoutVisibility(true);
                this.showInStoreOnlyCTA();
                return;
            }

            const clickCollectAvailable = this.hasClickCollectAvailableAnywhere(this.currentVariantId);
            const deliveryAvailable = this.isDeliveryAvailable(rawWarehouseStatus);
            const canPurchaseOnline = deliveryAvailable || clickCollectAvailable;

            if (!canPurchaseOnline) {
                this.updateDynamicCheckoutVisibility(true);
                this.clearScheduledDetachProductFormActions();
                this.restoreProductFormActions();

                const applyUnavailableCTA = () => {
                    if (this.shouldShowInStoreOnlyCTA()) {
                        this.showInStoreOnlyCTA();
                        return;
                    }

                    if (this.shouldShowOutOfStockCTA()) {
                        this.showOutOfStockCTA();
                        return;
                    }

                    this.setAddToCartButtonLabel(this.outOfStockText || 'Out of Stock');
                    this.setAddToCartButtonsDisabled(true);
                };

                applyUnavailableCTA();
                [100, 500, 1000, 2000].forEach((delay) => {
                    window.setTimeout(applyUnavailableCTA, delay);
                });
                return;
            }

            this.clearScheduledDetachProductFormActions();
            this.restoreProductFormActions();
            this.updateDynamicCheckoutVisibility(false);

            let buttonText = 'Add to Cart';
            let shouldDisable = false;
            const activeTab = this.activeTab || 'delivery';
            const isPickupMode = clickCollectAvailable
                && activeTab === 'click-collect'
                && this.hasStoreSelected();
            // _is_cc marks the item as pickup-only for fulfillment purposes, so it
            // should reflect availability (no delivery option), not just which tab
            // the shopper happens to be viewing.
            const isPickupOnly = !deliveryAvailable && clickCollectAvailable;

            if (this.requiresStoreSelection(rawWarehouseStatus)) {
                buttonText = 'Choose a store';
                shouldDisable = true;
            } else if (isPickupMode && isPickupOnly) {
                buttonText = 'Pickup in store';
            }

            const applyOnlinePurchaseCTA = () => {
                if (this.shouldShowInStoreOnlyCTA()) {
                    this.showInStoreOnlyCTA();
                    return;
                }

                this.syncPickupFormFields({
                    buttonText,
                    shouldDisable,
                    isPickupMode: isPickupMode && !this.requiresStoreSelection(rawWarehouseStatus),
                    isPickupOnly,
                });
            };

            applyOnlinePurchaseCTA();
            window.setTimeout(applyOnlinePurchaseCTA, 0);
        }

        updateDynamicCheckoutVisibility(shouldHide) {
            const applyVisibility = () => {
                document.querySelectorAll('.shopify-payment-button, .shopify-payment-button__more-options').forEach((element) => {
                    if (shouldHide) {
                        element.classList.add('hide');
                        element.setAttribute('aria-hidden', 'true');
                    } else {
                        element.classList.remove('hide');
                        element.removeAttribute('aria-hidden');
                    }
                });
            };

            applyVisibility();

            if (shouldHide) {
                [500, 1500].forEach((delay) => {
                    window.setTimeout(applyVisibility, delay);
                });
            }
        }

        async setStockAvailability(variantId, locationId) {
            const data = await this.getVariantAvailabilityByLocationId(variantId, locationId);
            if (data !== null) {
                this.ensureComponentVisible();
                const warehouseStatus = data.warehouseStockStatus || 'out-of-stock';
                this.currentWarehouseStatus = warehouseStatus;
                this.setStockStatusHtml(this.deliveryStatusElement, warehouseStatus);
                this.updateDeliveryTabState(warehouseStatus);
                this.updateFulfillmentVisibility(variantId, warehouseStatus);
                this.updateAddToCartButtonText(data);
                this.updateInStoreAvailability(variantId, warehouseStatus);

                if (!locationId || !this.currentStoreCookie) {
                    this.setClickCollectPanelWhenNoStore();
                    this.reCalculateAccordionHeight();
                    return;
                }

                this.setClickCollectStatusHtml(data, this.getStoreDisplayName(locationId));
            }

            this.reCalculateAccordionHeight();
        }

        toggleHide(element) {
            if (!element) return;
            element.classList.add('hide');
        }

        toggleShow(element) {
            if (!element) return;
            element.classList.remove('hide');
        }

        showPanelLayer(element) {
            if (!element) return;
            element.classList.remove('stock-display__panel--hidden');
        }

        hidePanelLayer(element) {
            if (!element) return;
            element.classList.add('stock-display__panel--hidden');
        }

        reCalculateAccordionHeight() {
            const accordionContent = this.closest('.accordion-content');
            if (accordionContent) {
                accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 15}px`;
            }
        }

        setCookie(name, value, days = 7) {
            if (value === null || value === undefined) {
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
                return;
            }

            const expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
            const cookieValue = JSON.stringify(value);
            document.cookie = `${name}=${encodeURIComponent(cookieValue)};expires=${expires.toUTCString()};path=/`;
        }

        getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) {
                    try {
                        return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length)));
                    } catch (e) {
                        console.error("Error parsing cookie value:", e);
                        return null;
                    }
                }
            }
            return null;
        }

        onVariantChange() {
            document.addEventListener('DOMContentLoaded', () => {
                const container1 = jQuery('[data-section-type="product"]');

                container1.on('variantChange', (event) => {
                    const variant = event.variant || event.detail?.variant;

                    if (variant.id) {
                        this.dataset.variantId = variant.id;
                        this.currentVariantId = variant.id;
                        this.variantInventoryQuantity = Math.max(variant.inventory_quantity ?? 0, 0);
                        this.initialDeliveryStateSet = false;
                        this.closeInStoreAvailabilityModal();
                        this.closeInStorePanel();
                        this.setStockAvailability(variant.id, this.currentLocationId);
                        this.buildStoreList(variant.id);
                    }
                });
            });
        }
    }

    customElements.define('stock-display', StockDisplay);
}
